import Http from "@/Http/Request";
import { useQuery } from "react-query";
import { UserProfileResponse } from "./types";



const getUserProfile = async () => {
	const { data } = await Http({
		method: 'GET',
		url: 'getUserProfileApi',
	});
	return data;
};

const useUserProfile = ({ enabled }: {enabled: boolean}) => {
	const { data, isLoading, error, refetch } = useQuery<UserProfileResponse, Error>({
		queryKey: ['userProfile'],
		queryFn: getUserProfile,
		enabled
	});


	
	return { data: data?.data, isLoading, error, refetch };
}

export default useUserProfile